import styles from "@/components/common/styles/pricing.module.scss";
import React, { useEffect, useState } from "react";
import { SubscriptionInfo } from "@/data/license.data";
import Loader from "@/components/common/loader";
import { useCoupon } from "@/components/pages/pricing-a/hooks/use-coupon";
import SubtypeButton, {
  SubType,
} from "@/components/pages/pricing-a/components/subtype-button";
import SubscriptionCard from "@/components/pages/pricing-a/components/subscription-card";

type Props = {
  handleAllFeaturesClick?: () => void;
  onUpgradeClick?: (
    isYearly: boolean,
    subscriptionInfo: SubscriptionInfo,
  ) => void;
};
const Pricing = ({ handleAllFeaturesClick, onUpgradeClick }: Props) => {
  const { coupon, tab, percent } = useCoupon();

  const [selectedSubType, setSelectedSubType] = useState<SubType>(
    selectedTabFactory(tab),
  );
  const supportedSubTypes = ["MONTHLY", "YEARLY"] as SubType[];

  const [subscriptions, setSubscriptions] = useState<SubscriptionInfo[]>();

  useEffect(() => {
    const loadSubscription = async () => {
      const response = await fetch("/api/subscriptions");
      const data = await response.json();
      setSubscriptions(data);
    };

    loadSubscription();
  }, []);

  const subtypes = (
    <div className={styles.subtype_wrapper}>
      {supportedSubTypes.map((subtype) => (
        <SubtypeButton
          key={subtype}
          setSubtype={(type) => setSelectedSubType(type)}
          selectedSubtype={selectedSubType}
          type={subtype}
        />
      ))}
    </div>
  );

  const header = handleAllFeaturesClick ? (
    <div className={styles.feature_header}>
      <div className={styles.spacer} />
      {subtypes}
      {handleAllFeaturesClick && (
        <div className={styles.view_features} onClick={handleAllFeaturesClick}>
          View Features
        </div>
      )}
    </div>
  ) : (
    <div className={styles.header}>{subtypes}</div>
  );

  return (
    <div className={styles.wrapper}>
      {header}
      <div className={styles.subscription_cards_wrapper}>
        {subscriptions ? (
          subscriptions.map((data) => (
            <SubscriptionCard
              key={data.title}
              subscriptionInfo={data}
              coupon={coupon}
              isYearly={selectedSubType === "YEARLY"}
              couponSalePercent={percent}
              onUpgradeClick={onUpgradeClick}
            />
          ))
        ) : (
          <div className={styles.loader_wrapper}>
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
};

const selectedTabFactory = (tab: string | null): SubType => {
  switch (tab) {
    case "month":
      return "MONTHLY";
    case "year":
      return "YEARLY";
    default:
      return "YEARLY";
  }
};

export default Pricing;
